import React from 'react';
import styles from './LoadingIndicator.module.css';
import messageStyles from '../chat-message/ChatMessage.module.css';
import logo from "../../assets/logo.png";
import { FiAlertTriangle } from 'react-icons/fi';

const LoadingIndicator = ({ asMessage = true, error = null, status = null, statusType = null, onDismissError = null }) => {
  // Display as a complete chat message
  if (asMessage) {
    return (
      <div className={messageStyles['chat-message']}>
        <div className={messageStyles['sender']}>
          <img src={logo} alt='Logo' className={messageStyles['sender-icon']} />
          <span className={messageStyles['sender-name']}>COMPAS</span>
        </div>
        <div className={messageStyles['message-content']}>
          <div className={styles['loading-indicator']}>
            {error ? (
              <div className={styles['loading-error-hint']}>
                <FiAlertTriangle className={styles['error-icon-small']} /> Failed
              </div>
            ) : (
              <div className={styles['loading-content']}>
                  <div className={styles['status-line']}>
                    <span className={`${styles['status-message']} ${statusType ? styles[`status-${statusType}`] : ''}`}>
                      {status || 'Processing request'}
                    </span>
                    <div className={styles['typing-dots']}>
                      <span></span>
                      <span></span>
                      <span></span>
                    </div>
                  </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  // Display as just the indicator (inline)
  return (
    <div className={`${styles['loading-indicator']} ${styles['inline']}`}>
      {error ? (
        <div className={`${styles['loading-error-hint']} ${styles['inline']}`}>
          <FiAlertTriangle className={styles['error-icon-small']} /> Failed
        </div>
      ) : (
        <div className={styles['loading-content']}>
          {status ? (
            <div className={styles['status-line']}>
              <span className={`${styles['status-message']} ${statusType ? styles[`status-${statusType}`] : ''}`}>
                {status}
              </span>
              <div className={styles['typing-dots']}>
                <span></span>
                <span></span>
                <span></span>
              </div>
            </div>
          ) : (
            <div className={styles['typing-dots']}>
              <span></span>
              <span></span>
              <span></span>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default LoadingIndicator; 